import vars from '../helpers';

let animatedElements = [];

const init = () => {
	const home = vars.$document.find('.home');

	function makeNewPosition() {
		const h = home.height() / 2 - 50;
		const w = home.width() / (vars.isMobile() ? 1 : 1.5 - 50);

		const nh = Math.floor(Math.random() * h);
		const nw = Math.floor(Math.random() * w);

		return [nh, nw];
	}

	function removeAnimation(elem) {
		if (animatedElements.indexOf(elem) >= 0) {
			animatedElements.splice(animatedElements.indexOf(elem), 1);

			gsap.killTweensOf(elem);
		}
	}

	function animateDiv(elem) {
		if (animatedElements.indexOf(elem) >= 0) {
			return;
		}

		animatedElements.push(elem);

		const position = makeNewPosition();

		gsap.to(elem, {
			onComplete() {
				removeAnimation(elem);

				if (document.querySelector(elem) !== null) {
					animateDiv(elem);
				}
			},
			duration: 2,
			ease: 'linear',
			x: position[1],
			y: position[0],
		});
	}

	animateDiv('.home__bg');
	// animateDiv('.preloader__bg');

	vars.$document.on('bg-destroy', (e, element) => {
		removeAnimation(element);
	});

	vars.$document.on('bg-play', (e, element) => {
		animateDiv(element);
	});
};

export default {
	init,
};
